module.exports = __webpack_public_path__ + "static/media/arrow-small-orange.a7e46064.svg";